import { VeiculoService } from 'src/app/services/geral/veiculo.service';
import { Veiculo } from 'src/app/model/geral/veiculo';
import { Component, Injector, OnInit } from '@angular/core';
import { FormGenerico } from '../../generic/formgenerico/formgenerico';
import { GeralFormModule } from './geralform.module';

@Component({
  selector: 'app-form-veiculo',
  templateUrl: '../../generic/formgenerico/formgenerico.component.html',
  styleUrls: [ '../../generic/formgenerico/formgenerico.component.css']
})

export class FormVeiculoComponent extends FormGenerico<Veiculo> implements OnInit {

  constructor(
    injectorObj: Injector,
    api: VeiculoService) 
  {
    super(injectorObj, api);
    this.obj = new Veiculo();
  }

  override ngOnInit(): void {
    super.ngOnInit();
  }

  override dataExtraObj(res: any) {
  }

  protected onPropertyChange(propName: string, newValue: any): void {}
}
